<template>
    <LoadingView v-if="loading" />
    <article v-if="!loading" class="bg-white shadow sm:rounded">

        <header class="px-4 py-5 border-b border-oakwood-gray-200 sm:px-6 flex items-center justify-between gap-8 sticky top-0 bg-white rounded-t-lg">
            <h1 class="text-3xl leading-9 font-medium font-headline antialiased  text-bhav-blue-700">
                Upload a New Survey
            </h1>
            <nav class="flex flex-none gap-4 justify-end items-center order-1 lg:order-2">
                <div class="flex-none">
                    <FormButton 
                        color="gray" @click="$router.go(-1)">
                        Cancel
                    </FormButton>
                </div>
                <div>
                    <FormButton @click="save" :disabled="!valid" color="blue">
                        Save
                    </FormButton>
                </div>
            </nav>
        </header>


        <form autocomplete="off" class="grid grid-cols-1 p-5 gap-5">

            <div class="grid grid-cols-1 md:grid-cols-5 pt-5">
                <p class="block text-sm font-medium leading-5  text-bhav-blue-300 sm:mt-px sm:pt-2">
                    Type
                </p>
                <p>
                    <label class="text-bhav-blue-500">
                        <input type="radio" name="type" v-model="type" value="xml" />
                        XML
                    </label>
                    <label class="text-bhav-blue-500">
                        <input type="radio" name="type" v-model="type" value="json" />
                        JSON
                    </label>
                </p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-5 pt-5">
                <p class="block text-sm font-medium leading-5  text-bhav-blue-300 sm:mt-px sm:pt-2">
                    File
                </p>
                <UploadFiles v-model="file" :multiple="false" class="md:col-span-3" format="file" :accept="type === 'xml' ? ['text/xml'] : ['application/json']" />
            </div>

            <div class="border-t border-t-oakwood-gray-200 grid grid-cols-1 md:grid-cols-5 pt-5">
                <label :for="`community`" class="block text-sm font-medium leading-5  text-bhav-blue-300 sm:mt-px sm:pt-2">
                    Community <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <div class="rounded-md shadow-sm md:col-span-3">
                    <p class="text-sm leading-5 text-oakwood-gray-500 mb-4">The survey must be associated with a community.</p>
                    <SelectField id="community" v-model="item.division_id" empty="Please Select..." :options="communities.filter(community => community.status != 'inactive').map(community => ( { label: community.meta?.info?.name, value: community.id } ))" />
                </div>
            </div>

            <div v-if="type === 'xml'" class="border-t border-t-oakwood-gray-200 grid grid-cols-1 md:grid-cols-5 pt-5">
                <label for="filing" class="block text-sm font-medium leading-5 text-bhav-blue-300 sm:mt-px sm:pt-2">
                    Filing
                </label>
                <div class="rounded-md shadow-sm md:col-span-3">
                    <p class="text-sm leading-5 text-oakwood-gray-500 mb-4">The filing number, when supplied, allows the system to perform accurate matches of parcels to lots.</p>
                    <TextInput id="filing" v-model="item.meta.filing" />
                </div>
            </div>
        </form>
        
    </article>
</template>

<script>
import axios from 'axios';
import LoadingView from '@/components/LoadingView.vue';
import { UploadFiles, FormButton, SelectField, TextInput } from '@/components/form';
import { systems, measurements } from '@/helpers/globals';
import { mapActions } from 'pinia';
import { useMessageStore } from "@/stores/message";

export default {
    data() {
        return {
            loading: true,
            counties: [],
            communities: [],
            type: 'xml',
            item: {
                division_id: null,
                filing: null,
                file: null,
                meta: {
                    unit: "USSurveyFoot",
                    system: 'EPSG:4269',
                    county: null
                }
            },
            systems,
            measurements
        }
    },
    methods: {
        ...mapActions(useMessageStore, ['setAlert']),
        save() {
            this.loading = true;
            axios.postForm('surveys', this.item)
                .then(resp => {
                    this.loading = false;
                    this.$router.push({name: 'survey-show', params: {id: resp.data.id}});
                })
                .catch(err => {
                    this.loading = false;
                    console.error(err);
                    this.setAlert({
                        level: 'error',
                        text: err.response.data.message
                    });
                })
        },
        indexCounties() {
            axios.get('surveys/counties')
                .then((resp) => {
                    this.loading = false;
                    this.counties = resp.data.sort((a,b) => a.name > b.name ? 1 : -1)
                })
                .catch(err => {
                    this.loading = false;
                    console.error(err);
                });
        },
        indexCommunities() {
            axios.get('divisions/communities')
                .then(resp => {
                    this.loading = false;
                    this.communities = resp.data.sort((a,b) => a.meta?.info?.name > b.meta?.info?.name ? 1 : -1);
                })
        },
    },
    computed: {
        valid() {
            let required = this.item.file && this.item.division_id && this.item.meta.unit && this.item.meta.system;

            // required = required && this.item.file.type === 'text/xml';
            return required;
        },
        file: {
            get() {
                return this.item.file == null ? [] : [this.item.file];
            },
            set(value) {
                this.item.file = value[0];
            }
        },
        availableCounties() {
            let counties = this.counties
            if(!this.item.collection_id) return counties;

            let collection = this.collections.find(collection => collection.id == this.item.collection_id) || false;
                
            if(collection && collection.kova?.SalesOfficeState) {
                counties = counties.filter(county => county.state == collection.kova.SalesOfficeState)
            }

            return counties;
        }
    },
    created() {
        this.indexCounties();
        this.indexCommunities();
    },
    components: {
        LoadingView, FormButton, SelectField, UploadFiles, TextInput
    }

}
</script>